import { IPriceListProcessData } from "common/records/PriceListProcess";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const FETCH_PROCESSES = "@priceListProcesses/FETCH_PROCESSES";
export const RECEIVE_PROCESSES = "@priceListProcesses/RECEIVE_PROCESSES";
export const RECEIVE_PROCESS_ERRORS = "@priceListProcesses/RECEIVE_PROCESS_ERRORS";

export const PriceListProcessActions = {
  fetchProcesses: () => createAction(FETCH_PROCESSES),
  receiveProcesses: (processes: Partial<IPriceListProcessData>) => createAction(RECEIVE_PROCESSES, processes),
  receiveProcessErrors: (errors: string[]) => createAction(RECEIVE_PROCESS_ERRORS, errors),
};

export type PriceListProcessActions = ActionsUnion<typeof PriceListProcessActions>;
